"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var Switch = function Switch(props) {
  var keyName = props.keyName,
      checked = props.checked,
      enabledText = props.enabledText,
      minWidth = props.minWidth,
      disabled = props.disabled,
      disabledText = props.disabledText,
      labelPosition = props.labelPosition,
      children = props.children,
      onChange = props.onChange;

  var handleChange = function handleChange(event) {
    onChange(event.target.checked);
  };

  var hasMultipleText = enabledText && disabledText;
  var hasSingleText = enabledText && !disabledText;
  var switchLabelClasses = (0, _classnames.default)('switch-label', disabled && 'cursor-not-allowed', labelPosition && "label-position-".concat(labelPosition));
  var switchContentClasses = (0, _classnames.default)('switch-content' //!hasMultipleText && !hasSingleText && 'width-40'
  );
  var switchContentStyles = {
    minWidth: minWidth
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: 'uikit-switch'
  }, /*#__PURE__*/_react.default.createElement("label", {
    className: switchLabelClasses
  }, /*#__PURE__*/_react.default.createElement("input", {
    onChange: handleChange,
    checked: checked,
    type: 'checkbox',
    id: keyName,
    key: keyName,
    className: 'switch-input',
    disabled: disabled
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: switchContentClasses,
    style: switchContentStyles
  }, hasMultipleText ? /*#__PURE__*/_react.default.createElement("div", {
    className: 'switch-text',
    "data-on": enabledText,
    "data-off": disabledText
  }) : hasSingleText && /*#__PURE__*/_react.default.createElement("div", {
    className: 'switch-text',
    "data-on": enabledText,
    "data-off": enabledText
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: 'switch-handle'
  })), children && children));
};

var _default = Switch;
exports.default = _default;
Switch.LABEL_POSITION_LEFT = 'left';
Switch.LABEL_POSITION_RIGHT = 'right';
Switch.defaultProps = {
  onChange: function onChange() {},
  keyName: '',
  checked: false,
  minWidth: 40,
  disabled: false
};
Switch.propTypes = {
  onChange: _propTypes.default.func.isRequired,
  checked: _propTypes.default.bool,
  keyName: _propTypes.default.string,
  minWidth: _propTypes.default.number,
  disabled: _propTypes.default.bool,
  enabledText: _propTypes.default.string,
  disabledText: _propTypes.default.string,
  labelPosition: _propTypes.default.oneOf([Switch.LABEL_POSITION_LEFT, Switch.LABEL_POSITION_RIGHT])
};